import * as Sentry from "@sentry/react";
import Clarity from "@microsoft/clarity";
import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Route, Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";

import history from "./components/utils/History";
import { AuthProvider } from "./context/auth-context";
import { fetchLiveEntry, runningEntry, startStaleBuildGuard } from "./staleBuild";
import store from "./store";

const clarityProjectId = "vxwahqu4hv";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://f6764ab42cb64497814e6f5c19e17916@o155481.ingest.sentry.io/1211676",
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.rewriteFramesIntegration({
        iteratee: (frame) => {
          if (frame?.filename.includes("/js/")) {
            return {
              ...frame,
              filename:
                frame.filename.substring(0, frame.filename.indexOf("/js/")) +
                frame.filename.substring(frame.filename.indexOf("/assets/")),
              abs_path:
                frame.filename.substring(0, frame.filename.indexOf("/js/")) +
                frame.filename.substring(frame.filename.indexOf("/assets/")),
            };
          }
          return frame;
        },
      }),
    ],
    ignoreErrors: [
      "Network Error",
      "Request failed with status code 401",
      "NotAllowedError: Read permission denied.",
      "Request failed with status code 422",
      "Request failed with status code 404",
      "Request failed with status code 429",
      "Request failed with status code 500",
      "Non-Error promise rejection captured with keys: invoice_number",
    ],
  });
  Clarity.init(clarityProjectId);
}

const Routes = () => {
  useEffect(() => {
    var script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAQrkqTXAPElNTcfd-y0FaZOqD584DDR8w&libraries=places&callback=initMap";
    script.async = true;

    // Attach your callback function to the `window` object
    window.initMap = function () {
      // JS API is loaded and available
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider>
        <Router history={history}>
          <Route path="/" component={App} />
          <ToastContainer />
        </Router>
      </AuthProvider>
    </Provider>
  );
};

// A tab that stays open across deploys must load a new page in full when the user changes page.
startStaleBuildGuard({
  history,
  running: runningEntry(document),
  fetchLive: () => fetchLiveEntry(),
  reload: () => window.location.reload(),
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <Routes />
  </ErrorBoundary>,
);
